var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: _vm.modalName,
            size: "lg",
            "hide-footer": "",
            title: "Détails de mon profil",
          },
        },
        [
          _vm.ProfilDetailsState
            ? [
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { staticClass: "display-details-container" },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              [
                                _c("list-show", {
                                  attrs: {
                                    list: _vm.list,
                                    source: _vm.ProfilDetailsState,
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("close-btn-container", { attrs: { modal_name: _vm.modalName } }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }